import React, { useState } from "react";
import { apiPost } from "../services/api";
import { saveToken } from "../services/auth";
import { Link } from "react-router-dom"; 
import Footer from "./Footer";  // ✅ Import Footer

const GBU_LOGO = "https://www.gbu.ac.in/Content/img/gbu_logo.png";

export default function GbuHostelLogin({ onLogin }) {
  const [enrollment, setEnrollment] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await apiPost("login", { enrollment, password });
      if (data.token) {
        saveToken(data.token);
        onLogin();
      } else {
        setError(data.error || "Invalid credentials.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-gradient-to-br from-blue-50 to-blue-200">
      {/* Center Content */}
      <div className="flex flex-col items-center justify-center flex-grow px-4">
        {/* Logo */}
        <div className="mb-8 animate-fade-in text-center">
          <img
            src={GBU_LOGO}
            alt="Gautam Buddha University Logo"
            className="h-24 mx-auto drop-shadow-lg"
          />
          <h1 className="text-2xl font-bold text-blue-900 mt-3 tracking-wide">
            Hostel Management System (OHMS)
          </h1>
          <h2 className="text-md text-blue-700 font-medium mt-1">
            Gautam Buddha University
          </h2>
        </div>

        {/* Login Form */}
        <form
          className="w-full max-w-sm bg-white rounded-xl shadow-lg p-8 animate-slide-up"
          onSubmit={handleSubmit}
        >
          <label className="block mb-2 text-sm font-medium text-blue-900">
            Enrollment / Roll Number
          </label>
          <input
            type="text"
            required
            value={enrollment}
            onChange={(e) => setEnrollment(e.target.value)}
            className="w-full px-4 py-2 mb-4 border border-blue-200 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
            placeholder="Enter your Enrollment or Roll Number"
          />

          <label className="block mb-2 text-sm font-medium text-blue-900">
            Password
          </label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 mb-2 border border-blue-200 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
            placeholder="Enter your password"
          />

          {/* Forgot Password & Register Link */}
          <div className="mb-4 flex justify-between text-sm">
            <Link
              to="/register"
              className="text-blue-700 hover:text-blue-900 font-medium"
            >
             Register Now
            </Link>
            <Link
              to="/forgot-password"
              className="text-blue-700 hover:text-blue-900 font-medium"
            >
              Forgot Password?
            </Link>
          </div>

      

          {error && (
            <div className="mb-4 text-red-600 text-sm font-semibold animate-shake">
              {error}
            </div>
          )}

          <button
            type="submit"
            className={`w-full py-2 rounded bg-blue-700 text-white font-semibold shadow-md hover:bg-blue-800 transition ${
              loading ? "opacity-60 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 018 8h-4l3 3 3-3h-4a8 8 0 01-8 8v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                  />
                </svg>
                Logging in...
              </span>
            ) : (
              "Login"
            )}
          </button>

          <Link
  to="/register"
  className="block w-full mt-3 text-center py-2 rounded border border-blue-600 text-blue-700 hover:bg-blue-50 font-semibold transition"
>
  New User? Register Now
</Link>
        </form>
      </div>

      {/* Footer */}
      <Footer />

      {/* Animations */}
      <style>
        {`
        .animate-fade-in {
          animation: fadeIn 1s ease;
        }
        .animate-slide-up {
          animation: slideUp 0.9s cubic-bezier(0.23, 1, 0.32, 1);
        }
        .animate-shake {
          animation: shake 0.4s;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-20px);}
          to { opacity: 1; transform: translateY(0);}
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px);}
          to { opacity: 1; transform: translateY(0);}
        }
        @keyframes shake {
          0% { transform: translateX(0);}
          20% { transform: translateX(-8px);}
          40% { transform: translateX(8px);}
          60% { transform: translateX(-8px);}
          80% { transform: translateX(8px);}
          100% { transform: translateX(0);}
        }
        `}
      </style>
    </div>
  );
}
